export enum ChangeKnoInMeasureActionsEnum {
  CHANGE_KNO_ERVK_ORGANIZATION_GET = 'CHANGE_KNO_MEASURE_ERVK_ORGANIZATION_GET',
  CHANGE_KNO_ERVK_ORGANIZATION_SET = 'CHANGE_KNO_MEASURE_ERVK_ORGANIZATION_SET',
  CHANGE_KNO_ERVK_ORGANIZATION_SET_SEARCH_QUERY = 'CHANGE_KNO_MEASURE_ERVK_ORGANIZATION_SET_SEARCH_QUERY',

  CHANGE_KNO_MEASURE_NUMBERS_GET = 'CHANGE_KNO_MEASURE_NUMBERS_GET',
  CHANGE_KNO_MEASURE_NUMBERS_SET = 'CHANGE_KNO_MEASURE_NUMBERS_SET',
  CHANGE_KNO_MEASURE_NUMBERS_SET_SEARCH_QUERY = 'CHANGE_KNO_MEASURE_NUMBERS_SET_SEARCH_QUERY',

  CHANGE_KNO_FORM_SUBMIT = 'CHANGE_KNO_MEASURE_FORM_SUBMIT',

  CHANGE_KNO_MEASURE_HISTORY_CHANGES_GET = 'CHANGE_KNO_MEASURE_HISTORY_CHANGES_GET',
  CHANGE_KNO_MEASURE_HISTORY_CHANGES_SET = 'CHANGE_KNO_MEASURE_HISTORY_CHANGES_SET',
}
